import { useContext } from 'react';
import { InterceptorContext } from './InterceptorProvider';

export function useInterceptorStore() {
  return useContext(InterceptorContext);
}
